
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingBOMDialog extends Common.GridEditorDialog<SKUSplittingBOMRow> {
        protected getFormKey() { return SKUSplittingBOMForm.formKey; }
        //protected getIdProperty() { return SKUSplittingBOMRow.idProperty; }
        protected getLocalTextPrefix() { return SKUSplittingBOMRow.localTextPrefix; }
        //protected getNameProperty() { return SKUSplittingBOMRow.nameProperty; }
        //protected getService() { return SKUSplittingBOMService.baseUrl; }
        protected getDeletePermission() { return SKUSplittingBOMRow.deletePermission; }
        protected getInsertPermission() { return SKUSplittingBOMRow.insertPermission; }
        protected getUpdatePermission() { return SKUSplittingBOMRow.updatePermission; }

        protected form = new SKUSplittingBOMForm(this.idPrefix);

    }
}